const Constants = {
  BASE_URL: "https://api.amenigies.com",
};

export default Constants;
